import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional().nullable(),
  ngay_ct2: z.string().optional().nullable(),
  kieu_xem: z.coerce.number().optional(),
  group_by: z.string().optional(),
  mau_bc: z.coerce.number().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  kieu_xem: 1,
  group_by: '',
  mau_bc: 20
};
